import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { trackPageView } from "./utils/analytics";
import Header from "./components/Header";
import PromoBanner from "./components/PromoBanner";
import Hero from "./components/Hero";
import MenuSection from "./components/MenuSection";
import Engagements from "./components/Engagements";
import CarteCompass from "./components/CarteCompass";
import Services from "./components/Services";
import Reviews from "./components/Reviews";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import StickyMobileButton from "./components/StickyMobileButton";
import { Toaster } from "./components/ui/sonner";

import PromoSection from "./components/PromoSection";

// Admin & Auth
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import AuthCallback from "./components/AuthCallback";
import ProtectedRoute from "./components/ProtectedRoute";

// Legal Pages
import PrivacyPolicy from "./pages/PrivacyPolicy";
import CookiesPolicy from "./pages/CookiesPolicy";
import LegalNotice from "./pages/LegalNotice";
import TermsOfService from "./pages/TermsOfService";

// Track page views
const PageViewTracker = () => {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname);
  }, [location]);

  return null;
};

const HomePage = () => {
  return (
    <>
      <Header />
      <PromoBanner />
      <main>
        <Hero />
        <PromoSection />
        <MenuSection />
        <CarteCompass />
        <Engagements />
        <Services />
        <Reviews />
        <Contact />
      </main>
      <Footer />
      <StickyMobileButton />
    </>
  );
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <PageViewTracker />
        <div className="App">
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<HomePage />} />
            
            {/* Legal Routes */}
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/cookies" element={<CookiesPolicy />} />
            <Route path="/legal" element={<LegalNotice />} />
            <Route path="/terms" element={<TermsOfService />} />

            {/* Auth Routes */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/callback" element={<AuthCallback />} />
            
            {/* Protected Admin Routes */}
            <Route
              path="/admin/dashboard"
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
          </Routes>
          <Toaster />
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
